import Api from './api'

/**
 * Creates audit messages for one app.
 */
export default class AppAuditer {
  application;
  menuItem;

  /**
   * Creates a new audit message creator for one app.
   * @param {*} application the App (for example RX, CPOE, eMAR)
   * @param {*} menuItem menu item (for example Scheduled Processes, Order Entry, Print Controller Query)
   */
  constructor(application, menuItem) {
    this.application = application;
    this.menuItem = menuItem;
  }

 /**
   * Writes a custom audit message for an action.
   * @param {string} action action (for example View, Show Patient Profile) - usually text on the button
   * @param {string} type string parsable to the AuditBO.emaType enum (for example Save, View, DC, Hold, Delete); leave at 'None' for actions which are only UI clicks and therefore not worth having their own enum value in AuditBO
   * @param {string} target target of the action (for example patient or order name)
   * @param {object} properties keys to other related entities like orders
   * @param {object} dataDictionary other key value pairs to be added to the audit record
   */
  writeCustomTypeAction(action, type, target = null, properties = {ordNo: null, account: null}, dataDictionary = null) {
    if(target || dataDictionary) {
      let actionWithTarget = {}
      actionWithTarget[action] = target

      if (dataDictionary) {
        for(var key in dataDictionary) {
          actionWithTarget[key] = dataDictionary[key]
        }
      }

      return Api.writeDataAction(this.application, this.menuItem, actionWithTarget, type, properties)
    }
    else {
      return Api.writeSimpleAction(this.application, this.menuItem, action, type, properties)
    }
  }

  /**
   * Writes an uncategorized (usually just a press of a button without any data consequence) audit message for an action.
   * @param {string} action action (for example View, Show Patient Profile) - usually text on the button
   * @param {string} target target of the action (for example patient or order name)
   * @param {object} properties keys to other related entities like orders
   */
  writeUncategorizedAction(action, target = null, properties = {ordNo: null, account: null}) {
    return this.writeCustomTypeAction(action, 'None', target, properties)
  }

  /**
   * Writes an audit message for a View type action.
   * @param {string} action action (for example View, Show Patient Profile) - usually text on the button
   * @param {string} target target of the action (for example patient or order name)
   * @param {object} properties keys to other related entities like orders
   */
  writeViewAction(action, target = null, properties = {ordNo: null, account: null}) {
    return this.writeCustomTypeAction(action, 'View', target, properties)
  }

   /**
   * Writes an audit message for a Save type action.
   * @param {string} action action (for example View, Show Patient Profile) - usually text on the button
   * @param {string} target target of the action (for example patient or order name)
   * @param {object} properties keys to other related entities like orders
   */
  writeSaveAction(action, target = null, properties = {ordNo: null, account: null}) {
    return this.writeCustomTypeAction(action, 'Save', target, properties)
  }
}
